import React, { useEffect, useState, useRef } from 'react';
import Loader from 'react-loaders';
import { useStateSelector } from '../../store/selectors';
import './BuyerNdaSign.scss';

interface BuyerNdaSignProps {
    documentId: number;
    onDocumentSign: () => void;
}

export const BuyerNdaSign = (props: BuyerNdaSignProps) => {
    const [isLoading, setIsLoading] = useState(true);
    const [embedUrl, setEmbedUrl] = useState('');
    const axios = useStateSelector((state) => state.core.axios);
    const pollingIntervalRef = useRef<NodeJS.Timeout | null>(null);

    useEffect(() => {
        setIsLoading(true);
        axios
            .get(`/api/Marketplace/MarketplaceBuyersNda/${props.documentId}/signUrl`)
            .then((response) => {
                setEmbedUrl(response.data);
            })
            .finally(() => setIsLoading(false));
    }, [props.documentId]);

    useEffect(() => {
        if (embedUrl) {
            pollingIntervalRef.current = setInterval(() => {
                checkIfSigned();
            }, 5000);
            return () => {
                if (pollingIntervalRef.current) {
                    clearInterval(pollingIntervalRef.current);
                }
            };
        }
    }, [embedUrl]);

    const checkIfSigned = () => {
        axios
            .get(`/api/Marketplace/MarketplaceBuyersNda/${props.documentId}/signed`)
            .then((response) => {
                if (response.data === true) {
                    if (pollingIntervalRef.current) {
                        clearInterval(pollingIntervalRef.current);
                    }
                    props.onDocumentSign();
                }
            });
    };

    const renderLoader = () => {
        return (
            <div className="loader-container" style={{ width: 'inherit' }}>
                <div className="loader-container-inner">
                    <div className="text-center">
                        <Loader active={isLoading} type="ball-scale-multiple" />
                    </div>
                    <h6 className="mt-5">Loading...</h6>
                </div>
            </div>
        );
    };

    return isLoading ? (
        renderLoader()
    ) : (
        <div className="buyer-nda-sign">
            <iframe
                title="Buyer NDA Signing"
                src={embedUrl}
            />
        </div>
    );
};

